/**
 * Нативные селекты в оболочке
 */
class Select {
    constructor(el) {
        this.container = el;
        this.select = this.container.querySelector('select');
        this.value = this.container.querySelector('.js-select-value');

        this.bindChange(this.select);
    }

    bindChange() {
        /**
         * Подставляем значение в заголовок селекта
         */
        this.select.addEventListener('change', e => {
            const val = e.target.value;
            const text = this.select.querySelector(`[value="${val}"]`).innerText;

            this.value.innerText = text;
        });
    }
}

document.querySelectorAll('.js-select').forEach(el => {
    new Select(el);
});



// WEBPACK FOOTER //
// ./_src/js/Select.js